import { DELETE_SHOPPING_LIST_ITEM } from "../../app/graphql/mutations";
import { useMutation } from "@apollo/client";

const useUpdateGroceryListFromRemovingMeal = () => {
  const [deleteeGroceryListItem, { loading }] = useMutation(DELETE_SHOPPING_LIST_ITEM);

  const updateGroceryListFromRemovingMeal = async ({ mealId }: { mealId: string }) => {
    try {
      await deleteeGroceryListItem({
        variables: {
          where: {
            meal_id: { _eq: mealId }
          }
        },
      });
    } catch (err) {
      console.error("Error deleting meal from shopping list item:", err);
    }
  }
  return {
    updatingGroceryListFromRemovingMeal: loading,
    updateGroceryListFromRemovingMeal,
  }
}

export default useUpdateGroceryListFromRemovingMeal